module.exports = __webpack_public_path__ + "img/CY110021.7609e849.png";